import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ndg, NdgRequest } from '../model/ndg';
import { SurveyForList } from '../model/survey-response';

@Injectable({
  providedIn: 'root'
})
export class NdgService {
  private _activeNdg?: Ndg;

  constructor(
    private http: HttpClient
  ) {}

  getNdgList(): Observable<Ndg[]> {
    return this.http.get<Ndg[]>(environment.api.ndg);
  }

  getNdg(ndg: string): Observable<Ndg> {
    return this.http.get<Ndg>(environment.api.ndg + '/' + ndg);
  }

  insertNewNdg(payload: NdgRequest): Observable<Ndg> {
    return this.http.post<Ndg>(environment.api.ndg, payload);
  }

  getNdgByClientId(clientId: string): Observable<Ndg> {
    return this.http.get<Ndg>(environment.api.ndg + '/client-id/' + clientId);
  }

  getSurveyList(ndg: string): Observable<SurveyForList[]> {
    return this.http.get<SurveyForList[]>(environment.api.ndg + '/' + ndg + '/survey');
  }

  set activeNdg(ndg: Ndg | undefined) {
    this._activeNdg = ndg;
  }

  get activeNdg(): Ndg | undefined {
    return this._activeNdg;
  }

  resetNdg(): void {
    this._activeNdg = undefined;
  }
}
